import { types } from 'mobx-state-tree';
import { partiallyUpdateModel } from '../definitions/Common';


export default types
    .model('Metadata', {
        completedPages: types.maybeNull(types.array(types.string)),
        lastVisitedPageId: types.maybeNull(types.string),
    })
    .actions(self => ({
        update(value) {
            partiallyUpdateModel(self, value);
        },
    }));
